//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class BaseAPI {
  constructor(protected configuration: Configuration) {}

  getBaseUrl(prefix: string, baseUrl: string) {
    const finalBaseUrl = baseUrl || this.configuration.basePath || BASE_PATH;

    return `${finalBaseUrl}${prefix}`;
  }

  async transformOptions(options: RequestInit): Promise<RequestInit> {
    if (options.headers) {
      let apiKey: string;
      if (this.configuration.apiKeyPromise) {
        apiKey = await this.configuration.apiKeyPromise();
      } else {
        apiKey = this.configuration.apiKey;
      }
      (options.headers as any)["authorization"] = apiKey;
      if (this.configuration.headers) {
        options.headers = {
          ...options.headers,
          ...this.configuration.headers,
        };
      }
      for (const middleware of this.configuration.middlewares) {
        options = (await middleware.pre(options)) || options;
      }
    }

    return Promise.resolve(options);
  }

  async transformResult(
    url: string,
    response: Response,
    processor: (response: Response) => Promise<any>
  ): Promise<any> {
    // is there middlware in configuration
    for (const middleware of this.configuration.middlewares) {
      response = (await middleware.post(response)) || response;
    }

    return processor(response);
  }
}

export interface IAccountApi {

    profile(x_Version?: string | null | undefined): Promise<UserProfileDto>;
}

export class AccountApi extends BaseAPI implements IAccountApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    profile(x_Version?: string | null | undefined): Promise<UserProfileDto> {
        let url_ = this.baseUrl + "/api/Account/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProfile(_response));
        });
    }

    protected processProfile(response: Response): Promise<UserProfileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfileDto>(null as any);
    }
}

export interface IActionGroupApi {

    getActionGroup(actionGroupId?: number | undefined, x_Version?: string | null | undefined): Promise<EditActionGroupDto>;

    saveActionGroup(dto: EditActionGroupDto, x_Version?: string | null | undefined): Promise<number>;

    deleteActionGroup(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse>;

    getActionGroupsTree(x_Version?: string | null | undefined): Promise<ActionGroupTreeItem[]>;

    baseSearch(sObj: ActionGroupSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfActionGroupGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class ActionGroupApi extends BaseAPI implements IActionGroupApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getActionGroup(actionGroupId?: number | undefined, x_Version?: string | null | undefined): Promise<EditActionGroupDto> {
        let url_ = this.baseUrl + "/api/ActionGroup?";
        if (actionGroupId === null)
            throw new Error("The parameter 'actionGroupId' cannot be null.");
        else if (actionGroupId !== undefined)
            url_ += "actionGroupId=" + encodeURIComponent("" + actionGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActionGroup(_response));
        });
    }

    protected processGetActionGroup(response: Response): Promise<EditActionGroupDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditActionGroupDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditActionGroupDto>(null as any);
    }

    saveActionGroup(dto: EditActionGroupDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/ActionGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveActionGroup(_response));
        });
    }

    protected processSaveActionGroup(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteActionGroup(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ActionGroup?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteActionGroup(_response));
        });
    }

    protected processDeleteActionGroup(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getActionGroupsTree(x_Version?: string | null | undefined): Promise<ActionGroupTreeItem[]> {
        let url_ = this.baseUrl + "/api/ActionGroup/action-group-tree";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActionGroupsTree(_response));
        });
    }

    protected processGetActionGroupsTree(response: Response): Promise<ActionGroupTreeItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActionGroupTreeItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActionGroupTreeItem[]>(null as any);
    }

    baseSearch(sObj: ActionGroupSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfActionGroupGridDto> {
        let url_ = this.baseUrl + "/api/ActionGroup/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfActionGroupGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfActionGroupGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfActionGroupGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/ActionGroup/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/ActionGroup/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IActionRoleApi {

    getAction(actionId?: number | undefined, x_Version?: string | null | undefined): Promise<EditActionDto>;

    saveAction(dto: EditActionDto, x_Version?: string | null | undefined): Promise<number>;

    updateActionRole(dto: UpdateActionRoleDto, x_Version?: string | null | undefined): Promise<FileResponse>;

    baseSearch(sObj: ActionRoleSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfActionGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class ActionRoleApi extends BaseAPI implements IActionRoleApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAction(actionId?: number | undefined, x_Version?: string | null | undefined): Promise<EditActionDto> {
        let url_ = this.baseUrl + "/api/ActionRole?";
        if (actionId === null)
            throw new Error("The parameter 'actionId' cannot be null.");
        else if (actionId !== undefined)
            url_ += "actionId=" + encodeURIComponent("" + actionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAction(_response));
        });
    }

    protected processGetAction(response: Response): Promise<EditActionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditActionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditActionDto>(null as any);
    }

    saveAction(dto: EditActionDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/ActionRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveAction(_response));
        });
    }

    protected processSaveAction(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateActionRole(dto: UpdateActionRoleDto, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ActionRole/UpdateActionRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateActionRole(_response));
        });
    }

    protected processUpdateActionRole(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    baseSearch(sObj: ActionRoleSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfActionGridDto> {
        let url_ = this.baseUrl + "/api/ActionRole/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfActionGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfActionGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfActionGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/ActionRole/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/ActionRole/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface ICustomerApi {

    get(id: number, x_Version?: string | null | undefined): Promise<CustomerEditDto>;

    getDisplayName(id: number, x_Version?: string | null | undefined): Promise<DisplayNameDto>;

    save(dto: CustomerEditDto, x_Version?: string | null | undefined): Promise<number>;

    getCustomerIdByUserIdentityId(identityId?: string | null | undefined, x_Version?: string | null | undefined): Promise<number[]>;

    getCustomerLanguageId(customerId?: number | undefined, x_Version?: string | null | undefined): Promise<number | null>;

    exportCustomerList(searchQuery: SearchQueryOfCustomerSearchCriteria, x_Version?: string | null | undefined): Promise<FileResponse>;

    baseSearch(searchQuery: SearchQueryOfCustomerSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfCustomerGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class CustomerApi extends BaseAPI implements ICustomerApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(id: number, x_Version?: string | null | undefined): Promise<CustomerEditDto> {
        let url_ = this.baseUrl + "/api/Customer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<CustomerEditDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerEditDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerEditDto>(null as any);
    }

    getDisplayName(id: number, x_Version?: string | null | undefined): Promise<DisplayNameDto> {
        let url_ = this.baseUrl + "/api/Customer/display-name/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<DisplayNameDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisplayNameDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisplayNameDto>(null as any);
    }

    save(dto: CustomerEditDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Customer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getCustomerIdByUserIdentityId(identityId?: string | null | undefined, x_Version?: string | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/api/Customer/get-by-user?";
        if (identityId !== undefined && identityId !== null)
            url_ += "identityId=" + encodeURIComponent("" + identityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCustomerIdByUserIdentityId(_response));
        });
    }

    protected processGetCustomerIdByUserIdentityId(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    getCustomerLanguageId(customerId?: number | undefined, x_Version?: string | null | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/Customer/get-language-id?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCustomerLanguageId(_response));
        });
    }

    protected processGetCustomerLanguageId(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    exportCustomerList(searchQuery: SearchQueryOfCustomerSearchCriteria, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Customer/export-users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportCustomerList(_response));
        });
    }

    protected processExportCustomerList(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfCustomerSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfCustomerGridDto> {
        let url_ = this.baseUrl + "/api/Customer/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfCustomerGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfCustomerGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfCustomerGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Customer/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Customer/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IDataTranslationApi {

    updateTranslation(updateTranslationCommand: UpdateDataTranslationCommand, x_Version?: string | null | undefined): Promise<FileResponse>;

    export(x_Version?: string | null | undefined): Promise<FileResponse>;

    upload(x_Version?: string | null | undefined, file?: FileParameter | null | undefined): Promise<Result>;

    getImportTemplate(x_Version?: string | null | undefined): Promise<FileResponse>;

    baseSearch(searchQuery: SearchQueryOfDataTranslationInfoSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfDataTranslationGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class DataTranslationApi extends BaseAPI implements IDataTranslationApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    updateTranslation(updateTranslationCommand: UpdateDataTranslationCommand, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DataTranslation/UpdateTranslation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateTranslationCommand);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateTranslation(_response));
        });
    }

    protected processUpdateTranslation(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    export(x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DataTranslation/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExport(_response));
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    upload(x_Version?: string | null | undefined, file?: FileParameter | null | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/DataTranslation/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpload(_response));
        });
    }

    protected processUpload(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getImportTemplate(x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DataTranslation/template";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetImportTemplate(_response));
        });
    }

    protected processGetImportTemplate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfDataTranslationInfoSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfDataTranslationGridDto> {
        let url_ = this.baseUrl + "/api/DataTranslation/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfDataTranslationGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDataTranslationGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDataTranslationGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/DataTranslation/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/DataTranslation/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IDeliveryOrderApi {

    downloadPdf(deliveryOrderId?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse>;

    downloadPdfList(deliveryOrderIds: number[], x_Version?: string | null | undefined): Promise<FileResponse>;

    get(id?: number | undefined, x_Version?: string | null | undefined): Promise<DeliveryOrderEditDto>;

    exportDeliveryOrderList(searchQuery: SearchQueryOfDeliveryOrderSearchDto, x_Version?: string | null | undefined): Promise<FileResponse>;

    baseSearch(searchQuery: SearchQueryOfDeliveryOrderSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfDeliveryOrderGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class DeliveryOrderApi extends BaseAPI implements IDeliveryOrderApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    downloadPdf(deliveryOrderId?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DeliveryOrder/download-pdf?";
        if (deliveryOrderId === null)
            throw new Error("The parameter 'deliveryOrderId' cannot be null.");
        else if (deliveryOrderId !== undefined)
            url_ += "deliveryOrderId=" + encodeURIComponent("" + deliveryOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadPdf(_response));
        });
    }

    protected processDownloadPdf(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadPdfList(deliveryOrderIds: number[], x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DeliveryOrder/download-pdf-list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deliveryOrderIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadPdfList(_response));
        });
    }

    protected processDownloadPdfList(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    get(id?: number | undefined, x_Version?: string | null | undefined): Promise<DeliveryOrderEditDto> {
        let url_ = this.baseUrl + "/api/DeliveryOrder/get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<DeliveryOrderEditDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryOrderEditDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeliveryOrderEditDto>(null as any);
    }

    exportDeliveryOrderList(searchQuery: SearchQueryOfDeliveryOrderSearchDto, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DeliveryOrder/export-delivery-orders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportDeliveryOrderList(_response));
        });
    }

    protected processExportDeliveryOrderList(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfDeliveryOrderSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfDeliveryOrderGridDto> {
        let url_ = this.baseUrl + "/api/DeliveryOrder/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfDeliveryOrderGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDeliveryOrderGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDeliveryOrderGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/DeliveryOrder/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/DeliveryOrder/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface ILanguageApi {

    getLanguages(x_Version?: string | null | undefined): Promise<LanguageDto[]>;
}

export class LanguageApi extends BaseAPI implements ILanguageApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getLanguages(x_Version?: string | null | undefined): Promise<LanguageDto[]> {
        let url_ = this.baseUrl + "/api/Language";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLanguages(_response));
        });
    }

    protected processGetLanguages(response: Response): Promise<LanguageDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LanguageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LanguageDto[]>(null as any);
    }
}

export interface IReferentialApi {

    actions(alreadyUsedActionIds: number[], x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    languages(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    roles(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    customers(idsToShowOnly?: number[] | undefined, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    customerTypes(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class ReferentialApi extends BaseAPI implements IReferentialApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    actions(alreadyUsedActionIds: number[], x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/actions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(alreadyUsedActionIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processActions(_response));
        });
    }

    protected processActions(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    languages(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/languages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLanguages(_response));
        });
    }

    protected processLanguages(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    roles(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRoles(_response));
        });
    }

    protected processRoles(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    customers(idsToShowOnly?: number[] | undefined, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/customers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(idsToShowOnly);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCustomers(_response));
        });
    }

    protected processCustomers(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    customerTypes(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/customer-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCustomerTypes(_response));
        });
    }

    protected processCustomerTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface ISearchCriteriaApi {

    getSearchCriteriaById(id: number, x_Version?: string | null | undefined): Promise<EditSearchCriteriaDto>;

    getSearchCriterias(userId?: number | null | undefined, x_Version?: string | null | undefined): Promise<EditSearchCriteriaDto[]>;

    saveSearchCriteria(dto: EditSearchCriteriaDto, x_Version?: string | null | undefined): Promise<number>;

    deleteSearchCriteria(name: string, x_Version?: string | null | undefined): Promise<FileResponse>;
}

export class SearchCriteriaApi extends BaseAPI implements ISearchCriteriaApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getSearchCriteriaById(id: number, x_Version?: string | null | undefined): Promise<EditSearchCriteriaDto> {
        let url_ = this.baseUrl + "/api/SearchCriteria/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriteriaById(_response));
        });
    }

    protected processGetSearchCriteriaById(response: Response): Promise<EditSearchCriteriaDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditSearchCriteriaDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditSearchCriteriaDto>(null as any);
    }

    getSearchCriterias(userId?: number | null | undefined, x_Version?: string | null | undefined): Promise<EditSearchCriteriaDto[]> {
        let url_ = this.baseUrl + "/api/SearchCriteria?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<EditSearchCriteriaDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EditSearchCriteriaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditSearchCriteriaDto[]>(null as any);
    }

    saveSearchCriteria(dto: EditSearchCriteriaDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/SearchCriteria";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveSearchCriteria(_response));
        });
    }

    protected processSaveSearchCriteria(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteSearchCriteria(name: string, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/SearchCriteria";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(name);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteSearchCriteria(_response));
        });
    }

    protected processDeleteSearchCriteria(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ISystemApi {

    get(x_Version?: string | null | undefined): Promise<SystemInfoDto>;

    getExposedTypes(x_Version?: string | null | undefined): Promise<ExposedTypes>;

    geFrontendSettings(x_Version?: string | null | undefined): Promise<FrontendSettings>;
}

export class SystemApi extends BaseAPI implements ISystemApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(x_Version?: string | null | undefined): Promise<SystemInfoDto> {
        let url_ = this.baseUrl + "/api/System";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<SystemInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemInfoDto>(null as any);
    }

    getExposedTypes(x_Version?: string | null | undefined): Promise<ExposedTypes> {
        let url_ = this.baseUrl + "/api/System/exposed-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetExposedTypes(_response));
        });
    }

    protected processGetExposedTypes(response: Response): Promise<ExposedTypes> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExposedTypes.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExposedTypes>(null as any);
    }

    geFrontendSettings(x_Version?: string | null | undefined): Promise<FrontendSettings> {
        let url_ = this.baseUrl + "/api/System/fe-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGeFrontendSettings(_response));
        });
    }

    protected processGeFrontendSettings(response: Response): Promise<FrontendSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FrontendSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FrontendSettings>(null as any);
    }
}

export interface ITranslationCodeApi {

    baseSearch(searchQuery: SearchQueryOfTranslationCodeSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfTranslationCodeDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class TranslationCodeApi extends BaseAPI implements ITranslationCodeApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(searchQuery: SearchQueryOfTranslationCodeSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfTranslationCodeDto> {
        let url_ = this.baseUrl + "/api/TranslationCode/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfTranslationCodeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfTranslationCodeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfTranslationCodeDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/TranslationCode/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/TranslationCode/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface ITranslationApi {

    getTranslationsGET(languageCode?: string | null | undefined, x_Version?: string | null | undefined): Promise<TranslationDto[]>;

    getTranslationsPOST(searchQuery: SearchQueryOfTranslationSearchCriteria, x_Version?: string | null | undefined): Promise<TranslationDto[]>;

    saveTranslation(languageCode: string, dto: SaveTranslationDto, x_Version?: string | null | undefined): Promise<void>;

    updateTranslation(updateTranslationCommand: UpdateTranslationCommand, x_Version?: string | null | undefined): Promise<FileResponse>;

    export(x_Version?: string | null | undefined): Promise<FileResponse>;

    deleteTranslationCode(translationCode?: string | null | undefined, x_Version?: string | null | undefined): Promise<boolean>;

    upload(x_Version?: string | null | undefined, file?: FileParameter | null | undefined): Promise<Result>;

    baseSearch(searchQuery: SearchQueryOfTranslationSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfTranslationDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class TranslationApi extends BaseAPI implements ITranslationApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getTranslationsGET(languageCode?: string | null | undefined, x_Version?: string | null | undefined): Promise<TranslationDto[]> {
        let url_ = this.baseUrl + "/api/Translation?";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTranslationsGET(_response));
        });
    }

    protected processGetTranslationsGET(response: Response): Promise<TranslationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TranslationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TranslationDto[]>(null as any);
    }

    getTranslationsPOST(searchQuery: SearchQueryOfTranslationSearchCriteria, x_Version?: string | null | undefined): Promise<TranslationDto[]> {
        let url_ = this.baseUrl + "/api/Translation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTranslationsPOST(_response));
        });
    }

    protected processGetTranslationsPOST(response: Response): Promise<TranslationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TranslationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TranslationDto[]>(null as any);
    }

    saveTranslation(languageCode: string, dto: SaveTranslationDto, x_Version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Translation/{languageCode}";
        if (languageCode === undefined || languageCode === null)
            throw new Error("The parameter 'languageCode' must be defined.");
        url_ = url_.replace("{languageCode}", encodeURIComponent("" + languageCode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveTranslation(_response));
        });
    }

    protected processSaveTranslation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateTranslation(updateTranslationCommand: UpdateTranslationCommand, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Translation/UpdateTranslation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateTranslationCommand);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateTranslation(_response));
        });
    }

    protected processUpdateTranslation(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    export(x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Translation/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExport(_response));
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteTranslationCode(translationCode?: string | null | undefined, x_Version?: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Translation/DeleteCode?";
        if (translationCode !== undefined && translationCode !== null)
            url_ += "translationCode=" + encodeURIComponent("" + translationCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteTranslationCode(_response));
        });
    }

    protected processDeleteTranslationCode(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    upload(x_Version?: string | null | undefined, file?: FileParameter | null | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Translation/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpload(_response));
        });
    }

    protected processUpload(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfTranslationSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfTranslationDto> {
        let url_ = this.baseUrl + "/api/Translation/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfTranslationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfTranslationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfTranslationDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Translation/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Translation/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IUserActionApi {

    baseSearch(sObj: UserActionSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfUserActionGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class UserActionApi extends BaseAPI implements IUserActionApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: UserActionSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfUserActionGridDto> {
        let url_ = this.baseUrl + "/api/UserAction/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfUserActionGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfUserActionGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfUserActionGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/UserAction/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/UserAction/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IUserApi {

    getUser(id: number, x_Version?: string | null | undefined): Promise<EditUserDto>;

    deleteUser(id: number, x_Version?: string | null | undefined): Promise<FileResponse>;

    saveUser(dto: EditUserDto, x_Version?: string | null | undefined): Promise<number>;

    getDisplayName(id: number, x_Version?: string | null | undefined): Promise<string>;

    profile(x_Version?: string | null | undefined): Promise<UserProfileDto>;

    exportUserList(searchQuery: SearchQueryOfUserSearchCriteria, x_Version?: string | null | undefined): Promise<FileResponse>;

    sendVerificationMail(userId?: number | undefined, x_Version?: string | null | undefined): Promise<number>;

    baseSearch(searchQuery: SearchQueryOfUserSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfUserGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class UserApi extends BaseAPI implements IUserApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getUser(id: number, x_Version?: string | null | undefined): Promise<EditUserDto> {
        let url_ = this.baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUser(_response));
        });
    }

    protected processGetUser(response: Response): Promise<EditUserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditUserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditUserDto>(null as any);
    }

    deleteUser(id: number, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteUser(_response));
        });
    }

    protected processDeleteUser(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveUser(dto: EditUserDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveUser(_response));
        });
    }

    protected processSaveUser(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDisplayName(id: number, x_Version?: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/User/display-name/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    profile(x_Version?: string | null | undefined): Promise<UserProfileDto> {
        let url_ = this.baseUrl + "/api/User/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProfile(_response));
        });
    }

    protected processProfile(response: Response): Promise<UserProfileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfileDto>(null as any);
    }

    exportUserList(searchQuery: SearchQueryOfUserSearchCriteria, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/User/export-users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportUserList(_response));
        });
    }

    protected processExportUserList(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    sendVerificationMail(userId?: number | undefined, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/User/send-verification-email?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSendVerificationMail(_response));
        });
    }

    protected processSendVerificationMail(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfUserSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfUserGridDto> {
        let url_ = this.baseUrl + "/api/User/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfUserGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfUserGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfUserGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/User/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/User/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IHealthCheckApi {

    getHealthCheck(x_Version?: string | null | undefined): Promise<HealthCheckViewModel>;

    getStartupHealthCheck(x_Version?: string | null | undefined): Promise<HealthCheckViewModel>;

    getReadyHealthCheck(x_Version?: string | null | undefined): Promise<HealthCheckViewModel>;

    getLiveHealthCheck(x_Version?: string | null | undefined): Promise<HealthCheckViewModel>;
}

export class HealthCheckApi extends BaseAPI implements IHealthCheckApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getHealthCheck(x_Version?: string | null | undefined): Promise<HealthCheckViewModel> {
        let url_ = this.baseUrl + "/monitoring/_hc";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHealthCheck(_response));
        });
    }

    protected processGetHealthCheck(response: Response): Promise<HealthCheckViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCheckViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCheckViewModel>(null as any);
    }

    getStartupHealthCheck(x_Version?: string | null | undefined): Promise<HealthCheckViewModel> {
        let url_ = this.baseUrl + "/monitoring/_hc/startup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStartupHealthCheck(_response));
        });
    }

    protected processGetStartupHealthCheck(response: Response): Promise<HealthCheckViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCheckViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCheckViewModel>(null as any);
    }

    getReadyHealthCheck(x_Version?: string | null | undefined): Promise<HealthCheckViewModel> {
        let url_ = this.baseUrl + "/monitoring/_hc/ready";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetReadyHealthCheck(_response));
        });
    }

    protected processGetReadyHealthCheck(response: Response): Promise<HealthCheckViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCheckViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCheckViewModel>(null as any);
    }

    getLiveHealthCheck(x_Version?: string | null | undefined): Promise<HealthCheckViewModel> {
        let url_ = this.baseUrl + "/monitoring/_hc/live";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLiveHealthCheck(_response));
        });
    }

    protected processGetLiveHealthCheck(response: Response): Promise<HealthCheckViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCheckViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCheckViewModel>(null as any);
    }
}

export interface IApiKeyApi {

    getApiKey(clientName?: string | null | undefined, x_Version?: string | null | undefined): Promise<ClientApiKey>;
}

export class ApiKeyApi extends BaseAPI implements IApiKeyApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getApiKey(clientName?: string | null | undefined, x_Version?: string | null | undefined): Promise<ClientApiKey> {
        let url_ = this.baseUrl + "/apikey?";
        if (clientName !== undefined && clientName !== null)
            url_ += "clientName=" + encodeURIComponent("" + clientName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetApiKey(_response));
        });
    }

    protected processGetApiKey(response: Response): Promise<ClientApiKey> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientApiKey.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientApiKey>(null as any);
    }
}

export class UserProfileDto implements IUserProfileDto {
    userId?: string | undefined;
    login?: string | undefined;
    identityServiceId?: string | undefined;
    languageCode?: string | undefined;
    actions?: ActionCode[] | undefined;

    constructor(data?: IUserProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.login = _data["login"];
            this.identityServiceId = _data["identityServiceId"];
            this.languageCode = _data["languageCode"];
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(item);
            }
        }
    }

    static fromJS(data: any): UserProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["login"] = this.login;
        data["identityServiceId"] = this.identityServiceId;
        data["languageCode"] = this.languageCode;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item);
        }
        return data;
    }

    clone(): UserProfileDto {
        const json = this.toJSON();
        let result = new UserProfileDto();
        result.init(json);
        return result;
    }
}

export interface IUserProfileDto {
    userId?: string | undefined;
    login?: string | undefined;
    identityServiceId?: string | undefined;
    languageCode?: string | undefined;
    actions?: ActionCode[] | undefined;
}

export enum ActionCode {
    ManageJobs = "ManageJobs",
    ViewActionGroup = "ViewActionGroup",
    EditActionGroup = "EditActionGroup",
    ViewRoles = "ViewRoles",
    EditRoles = "EditRoles",
    EditDataTranslations = "EditDataTranslations",
    ViewCriterias = "ViewCriterias",
    EditCriterias = "EditCriterias",
    EditTranslations = "EditTranslations",
    ViewUserActions = "ViewUserActions",
    EditUserActions = "EditUserActions",
    ViewUser = "ViewUser",
    EditUser = "EditUser",
    ViewCustomer = "ViewCustomer",
    EditCustomer = "EditCustomer",
    ViewDeliveryOrders = "ViewDeliveryOrders",
    DownloadPdf = "DownloadPdf",
    CanFilterDeliveryOrderByCustomer = "CanFilterDeliveryOrderByCustomer",
    CanViewCanceledDeliveryOrder = "CanViewCanceledDeliveryOrder",
    EditUserWithUserRoleOnly = "EditUserWithUserRoleOnly",
    ExportDeliveryOrders = "ExportDeliveryOrders",
    ExportUsers = "ExportUsers",
    ExportCustomers = "ExportCustomers",
}

export class EditActionGroupDto implements IEditActionGroupDto {
    id?: number;
    code?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;
    parentActionGroupId?: number | undefined;

    constructor(data?: IEditActionGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationDto.fromJS(_data["dataTranslation"]) : <any>undefined;
            this.parentActionGroupId = _data["parentActionGroupId"];
        }
    }

    static fromJS(data: any): EditActionGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditActionGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : <any>undefined;
        data["parentActionGroupId"] = this.parentActionGroupId;
        return data;
    }

    clone(): EditActionGroupDto {
        const json = this.toJSON();
        let result = new EditActionGroupDto();
        result.init(json);
        return result;
    }
}

export interface IEditActionGroupDto {
    id?: number;
    code?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;
    parentActionGroupId?: number | undefined;
}

export class EntityDto implements IEntityDto {
    id?: number;

    constructor(data?: IEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): EntityDto {
        const json = this.toJSON();
        let result = new EntityDto();
        result.init(json);
        return result;
    }
}

export interface IEntityDto {
    id?: number;
}

export class DataTranslationDto extends EntityDto implements IDataTranslationDto {
    dataTranslationValues?: DataTranslationValueDto[] | undefined;

    constructor(data?: IDataTranslationDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["dataTranslationValues"])) {
                this.dataTranslationValues = [] as any;
                for (let item of _data["dataTranslationValues"])
                    this.dataTranslationValues!.push(DataTranslationValueDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): DataTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataTranslationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dataTranslationValues)) {
            data["dataTranslationValues"] = [];
            for (let item of this.dataTranslationValues)
                data["dataTranslationValues"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): DataTranslationDto {
        const json = this.toJSON();
        let result = new DataTranslationDto();
        result.init(json);
        return result;
    }
}

export interface IDataTranslationDto extends IEntityDto {
    dataTranslationValues?: DataTranslationValueDto[] | undefined;
}

export class DataTranslationValueDto extends EntityDto implements IDataTranslationValueDto {
    text?: string | undefined;
    languageId?: number;
    languageCode?: string | undefined;

    constructor(data?: IDataTranslationValueDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.text = _data["text"];
            this.languageId = _data["languageId"];
            this.languageCode = _data["languageCode"];
        }
    }

    static override fromJS(data: any): DataTranslationValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataTranslationValueDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["languageId"] = this.languageId;
        data["languageCode"] = this.languageCode;
        super.toJSON(data);
        return data;
    }

    clone(): DataTranslationValueDto {
        const json = this.toJSON();
        let result = new DataTranslationValueDto();
        result.init(json);
        return result;
    }
}

export interface IDataTranslationValueDto extends IEntityDto {
    text?: string | undefined;
    languageId?: number;
    languageCode?: string | undefined;
}

export class ActionGroupTreeItem implements IActionGroupTreeItem {
    id?: number;
    code?: string | undefined;
    label?: string | undefined;
    children?: ActionGroupTreeItem[] | undefined;

    constructor(data?: IActionGroupTreeItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.label = _data["label"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(ActionGroupTreeItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActionGroupTreeItem {
        data = typeof data === 'object' ? data : {};
        let result = new ActionGroupTreeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["label"] = this.label;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }

    clone(): ActionGroupTreeItem {
        const json = this.toJSON();
        let result = new ActionGroupTreeItem();
        result.init(json);
        return result;
    }
}

export interface IActionGroupTreeItem {
    id?: number;
    code?: string | undefined;
    label?: string | undefined;
    children?: ActionGroupTreeItem[] | undefined;
}

export class PaginatedResultsOfActionGroupGridDto implements IPaginatedResultsOfActionGroupGridDto {
    totalCount?: number;
    results?: ActionGroupGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfActionGroupGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ActionGroupGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfActionGroupGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfActionGroupGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfActionGroupGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfActionGroupGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfActionGroupGridDto {
    totalCount?: number;
    results?: ActionGroupGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class ActionGroupGridDto implements IActionGroupGridDto {

    constructor(data?: IActionGroupGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ActionGroupGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionGroupGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): ActionGroupGridDto {
        const json = this.toJSON();
        let result = new ActionGroupGridDto();
        result.init(json);
        return result;
    }
}

export interface IActionGroupGridDto {
}

export class AggregateResult implements IAggregateResult {
    valueDouble?: number | undefined;
    valueDec?: number | undefined;
    valueFloat?: number | undefined;
    key?: string | undefined;
    text?: string | undefined;
    value?: number | undefined;

    constructor(data?: IAggregateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valueDouble = _data["valueDouble"];
            this.valueDec = _data["valueDec"];
            this.valueFloat = _data["valueFloat"];
            this.key = _data["key"];
            this.text = _data["text"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): AggregateResult {
        data = typeof data === 'object' ? data : {};
        let result = new AggregateResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valueDouble"] = this.valueDouble;
        data["valueDec"] = this.valueDec;
        data["valueFloat"] = this.valueFloat;
        data["key"] = this.key;
        data["text"] = this.text;
        data["value"] = this.value;
        return data;
    }

    clone(): AggregateResult {
        const json = this.toJSON();
        let result = new AggregateResult();
        result.init(json);
        return result;
    }
}

export interface IAggregateResult {
    valueDouble?: number | undefined;
    valueDec?: number | undefined;
    valueFloat?: number | undefined;
    key?: string | undefined;
    text?: string | undefined;
    value?: number | undefined;
}

export class FilterSearch implements IFilterSearch {
    filter?: string | undefined;

    constructor(data?: IFilterSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FilterSearch {
        data = typeof data === 'object' ? data : {};
        let result = new FilterSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        return data;
    }

    clone(): FilterSearch {
        const json = this.toJSON();
        let result = new FilterSearch();
        result.init(json);
        return result;
    }
}

export interface IFilterSearch {
    filter?: string | undefined;
}

export class PaginatedSearch extends FilterSearch implements IPaginatedSearch {
    sortKey?: string[] | undefined;
    aggregateKeys?: AggregateKeyInfo[] | undefined;
    forceSkip?: number | undefined;
    forceTake?: number | undefined;
    parameters?: any | undefined;

    constructor(data?: IPaginatedSearch) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["sortKey"])) {
                this.sortKey = [] as any;
                for (let item of _data["sortKey"])
                    this.sortKey!.push(item);
            }
            if (Array.isArray(_data["aggregateKeys"])) {
                this.aggregateKeys = [] as any;
                for (let item of _data["aggregateKeys"])
                    this.aggregateKeys!.push(AggregateKeyInfo.fromJS(item));
            }
            this.forceSkip = _data["forceSkip"];
            this.forceTake = _data["forceTake"];
            this.parameters = _data["parameters"];
        }
    }

    static override fromJS(data: any): PaginatedSearch {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedSearch();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sortKey)) {
            data["sortKey"] = [];
            for (let item of this.sortKey)
                data["sortKey"].push(item);
        }
        if (Array.isArray(this.aggregateKeys)) {
            data["aggregateKeys"] = [];
            for (let item of this.aggregateKeys)
                data["aggregateKeys"].push(item.toJSON());
        }
        data["forceSkip"] = this.forceSkip;
        data["forceTake"] = this.forceTake;
        data["parameters"] = this.parameters;
        super.toJSON(data);
        return data;
    }

    clone(): PaginatedSearch {
        const json = this.toJSON();
        let result = new PaginatedSearch();
        result.init(json);
        return result;
    }
}

export interface IPaginatedSearch extends IFilterSearch {
    sortKey?: string[] | undefined;
    aggregateKeys?: AggregateKeyInfo[] | undefined;
    forceSkip?: number | undefined;
    forceTake?: number | undefined;
    parameters?: any | undefined;
}

export class ActionGroupSearchDto extends PaginatedSearch implements IActionGroupSearchDto {

    constructor(data?: IActionGroupSearchDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ActionGroupSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionGroupSearchDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ActionGroupSearchDto {
        const json = this.toJSON();
        let result = new ActionGroupSearchDto();
        result.init(json);
        return result;
    }
}

export interface IActionGroupSearchDto extends IPaginatedSearch {
}

export class AggregateKeyInfo implements IAggregateKeyInfo {
    key?: string | undefined;
    aggregateType?: EAggregateType;
    text?: string | undefined;

    constructor(data?: IAggregateKeyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.aggregateType = _data["aggregateType"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): AggregateKeyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AggregateKeyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["aggregateType"] = this.aggregateType;
        data["text"] = this.text;
        return data;
    }

    clone(): AggregateKeyInfo {
        const json = this.toJSON();
        let result = new AggregateKeyInfo();
        result.init(json);
        return result;
    }
}

export interface IAggregateKeyInfo {
    key?: string | undefined;
    aggregateType?: EAggregateType;
    text?: string | undefined;
}

export enum EAggregateType {
    Sum = "Sum",
    Avg = "Avg",
    Min = "Min",
    Max = "Max",
}

export class FilterCriteriaInfo implements IFilterCriteriaInfo {
    criteria?: string | undefined;
    type?: ECriteriaType;
    searchModes?: string[] | undefined;
    defaultSearchMode?: string | undefined;
    listValues?: SelectItem[] | undefined;
    isMultipleOr?: boolean;

    constructor(data?: IFilterCriteriaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.criteria = _data["criteria"];
            this.type = _data["type"];
            if (Array.isArray(_data["searchModes"])) {
                this.searchModes = [] as any;
                for (let item of _data["searchModes"])
                    this.searchModes!.push(item);
            }
            this.defaultSearchMode = _data["defaultSearchMode"];
            if (Array.isArray(_data["listValues"])) {
                this.listValues = [] as any;
                for (let item of _data["listValues"])
                    this.listValues!.push(SelectItem.fromJS(item));
            }
            this.isMultipleOr = _data["isMultipleOr"];
        }
    }

    static fromJS(data: any): FilterCriteriaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FilterCriteriaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteria"] = this.criteria;
        data["type"] = this.type;
        if (Array.isArray(this.searchModes)) {
            data["searchModes"] = [];
            for (let item of this.searchModes)
                data["searchModes"].push(item);
        }
        data["defaultSearchMode"] = this.defaultSearchMode;
        if (Array.isArray(this.listValues)) {
            data["listValues"] = [];
            for (let item of this.listValues)
                data["listValues"].push(item.toJSON());
        }
        data["isMultipleOr"] = this.isMultipleOr;
        return data;
    }

    clone(): FilterCriteriaInfo {
        const json = this.toJSON();
        let result = new FilterCriteriaInfo();
        result.init(json);
        return result;
    }
}

export interface IFilterCriteriaInfo {
    criteria?: string | undefined;
    type?: ECriteriaType;
    searchModes?: string[] | undefined;
    defaultSearchMode?: string | undefined;
    listValues?: SelectItem[] | undefined;
    isMultipleOr?: boolean;
}

export enum ECriteriaType {
    Text = "Text",
    List = "List",
    Date = "Date",
    Boolean = "Boolean",
    Numeric = "Numeric",
    Float = "Float",
}

export class SelectItem implements ISelectItem {
    idValue?: string | undefined;
    displayValue?: string | undefined;

    constructor(data?: ISelectItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idValue = _data["idValue"];
            this.displayValue = _data["displayValue"];
        }
    }

    static fromJS(data: any): SelectItem {
        data = typeof data === 'object' ? data : {};
        let result = new SelectItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idValue"] = this.idValue;
        data["displayValue"] = this.displayValue;
        return data;
    }

    clone(): SelectItem {
        const json = this.toJSON();
        let result = new SelectItem();
        result.init(json);
        return result;
    }
}

export interface ISelectItem {
    idValue?: string | undefined;
    displayValue?: string | undefined;
}

export class ReferentialItemDto extends SelectItem implements IReferentialItemDto {
    keyValue?: string | undefined;

    constructor(data?: IReferentialItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.keyValue = _data["keyValue"];
        }
    }

    static override fromJS(data: any): ReferentialItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferentialItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyValue"] = this.keyValue;
        super.toJSON(data);
        return data;
    }

    clone(): ReferentialItemDto {
        const json = this.toJSON();
        let result = new ReferentialItemDto();
        result.init(json);
        return result;
    }
}

export interface IReferentialItemDto extends ISelectItem {
    keyValue?: string | undefined;
}

export class EditActionDto implements IEditActionDto {
    id?: number;
    code?: ActionCode;
    name?: string | undefined;
    actionGroupId?: number | undefined;

    constructor(data?: IEditActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.actionGroupId = _data["actionGroupId"];
        }
    }

    static fromJS(data: any): EditActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["actionGroupId"] = this.actionGroupId;
        return data;
    }

    clone(): EditActionDto {
        const json = this.toJSON();
        let result = new EditActionDto();
        result.init(json);
        return result;
    }
}

export interface IEditActionDto {
    id?: number;
    code?: ActionCode;
    name?: string | undefined;
    actionGroupId?: number | undefined;
}

export class UpdateActionRoleDto implements IUpdateActionRoleDto {
    roleId?: number;
    actionId?: number;
    isActive?: boolean;

    constructor(data?: IUpdateActionRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.actionId = _data["actionId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateActionRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateActionRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["actionId"] = this.actionId;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): UpdateActionRoleDto {
        const json = this.toJSON();
        let result = new UpdateActionRoleDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateActionRoleDto {
    roleId?: number;
    actionId?: number;
    isActive?: boolean;
}

export class PaginatedResultsOfActionGridDto implements IPaginatedResultsOfActionGridDto {
    totalCount?: number;
    results?: ActionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfActionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ActionGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfActionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfActionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfActionGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfActionGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfActionGridDto {
    totalCount?: number;
    results?: ActionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class ActionGridDto implements IActionGridDto {
    id?: number;
    actionName?: string | undefined;
    code?: ActionCode;
    actionGroup?: string | undefined;
    actionRoles?: ActionRoleDto[] | undefined;
    dataTranslation?: DataTranslationDto | undefined;

    constructor(data?: IActionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.actionName = _data["actionName"];
            this.code = _data["code"];
            this.actionGroup = _data["actionGroup"];
            if (Array.isArray(_data["actionRoles"])) {
                this.actionRoles = [] as any;
                for (let item of _data["actionRoles"])
                    this.actionRoles!.push(ActionRoleDto.fromJS(item));
            }
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationDto.fromJS(_data["dataTranslation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["actionName"] = this.actionName;
        data["code"] = this.code;
        data["actionGroup"] = this.actionGroup;
        if (Array.isArray(this.actionRoles)) {
            data["actionRoles"] = [];
            for (let item of this.actionRoles)
                data["actionRoles"].push(item.toJSON());
        }
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : <any>undefined;
        return data;
    }

    clone(): ActionGridDto {
        const json = this.toJSON();
        let result = new ActionGridDto();
        result.init(json);
        return result;
    }
}

export interface IActionGridDto {
    id?: number;
    actionName?: string | undefined;
    code?: ActionCode;
    actionGroup?: string | undefined;
    actionRoles?: ActionRoleDto[] | undefined;
    dataTranslation?: DataTranslationDto | undefined;
}

export class ActionRoleDto implements IActionRoleDto {
    id?: number;
    roleName?: string | undefined;
    actionId?: number;
    roleId?: number;
    code?: UserRoles;
    actionCode?: ActionCode;

    constructor(data?: IActionRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.roleName = _data["roleName"];
            this.actionId = _data["actionId"];
            this.roleId = _data["roleId"];
            this.code = _data["code"];
            this.actionCode = _data["actionCode"];
        }
    }

    static fromJS(data: any): ActionRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roleName"] = this.roleName;
        data["actionId"] = this.actionId;
        data["roleId"] = this.roleId;
        data["code"] = this.code;
        data["actionCode"] = this.actionCode;
        return data;
    }

    clone(): ActionRoleDto {
        const json = this.toJSON();
        let result = new ActionRoleDto();
        result.init(json);
        return result;
    }
}

export interface IActionRoleDto {
    id?: number;
    roleName?: string | undefined;
    actionId?: number;
    roleId?: number;
    code?: UserRoles;
    actionCode?: ActionCode;
}

export enum UserRoles {
    SuperAdmin = "SuperAdmin",
    Admin = "Admin",
    User = "User",
}

export class ActionRoleSearchDto extends PaginatedSearch implements IActionRoleSearchDto {
    parentActionGroupId?: number | undefined;

    constructor(data?: IActionRoleSearchDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.parentActionGroupId = _data["parentActionGroupId"];
        }
    }

    static override fromJS(data: any): ActionRoleSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionRoleSearchDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentActionGroupId"] = this.parentActionGroupId;
        super.toJSON(data);
        return data;
    }

    clone(): ActionRoleSearchDto {
        const json = this.toJSON();
        let result = new ActionRoleSearchDto();
        result.init(json);
        return result;
    }
}

export interface IActionRoleSearchDto extends IPaginatedSearch {
    parentActionGroupId?: number | undefined;
}

export class CustomerEditDto implements ICustomerEditDto {
    id?: number;
    languageId?: number;
    name?: string | undefined;
    isActive?: boolean;
    code?: string | undefined;
    customerType?: ECustomerType;

    constructor(data?: ICustomerEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.languageId = _data["languageId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.code = _data["code"];
            this.customerType = _data["customerType"];
        }
    }

    static fromJS(data: any): CustomerEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["languageId"] = this.languageId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["code"] = this.code;
        data["customerType"] = this.customerType;
        return data;
    }

    clone(): CustomerEditDto {
        const json = this.toJSON();
        let result = new CustomerEditDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerEditDto {
    id?: number;
    languageId?: number;
    name?: string | undefined;
    isActive?: boolean;
    code?: string | undefined;
    customerType?: ECustomerType;
}

export enum ECustomerType {
    CCB = "CCB",
    CCBF = "CCBF",
}

export class DisplayNameDto implements IDisplayNameDto {
    text?: string | undefined;
    id?: number | undefined;

    constructor(data?: IDisplayNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DisplayNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new DisplayNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["id"] = this.id;
        return data;
    }

    clone(): DisplayNameDto {
        const json = this.toJSON();
        let result = new DisplayNameDto();
        result.init(json);
        return result;
    }
}

export interface IDisplayNameDto {
    text?: string | undefined;
    id?: number | undefined;
}

export class SearchQueryOfCustomerSearchCriteria implements ISearchQueryOfCustomerSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: CustomerSearchCriteria | undefined;

    constructor(data?: ISearchQueryOfCustomerSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? CustomerSearchCriteria.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfCustomerSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfCustomerSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfCustomerSearchCriteria {
        const json = this.toJSON();
        let result = new SearchQueryOfCustomerSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfCustomerSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: CustomerSearchCriteria | undefined;
}

export abstract class AbstractSearchExpression implements IAbstractSearchExpression {
    expressionOperator?: string | undefined;

    protected _discriminator: string;

    constructor(data?: IAbstractSearchExpression) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "AbstractSearchExpression";
    }

    init(_data?: any) {
        if (_data) {
            this.expressionOperator = _data["expressionOperator"];
        }
    }

    static fromJS(data: any): AbstractSearchExpression {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "condition") {
            let result = new ConditionSearchExpression();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "group") {
            let result = new GroupSearchExpression();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'AbstractSearchExpression' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["expressionOperator"] = this.expressionOperator;
        return data;
    }

    clone(): AbstractSearchExpression {
        throw new Error("The abstract class 'AbstractSearchExpression' cannot be instantiated.");
    }
}

export interface IAbstractSearchExpression {
    expressionOperator?: string | undefined;
}

export class ConditionSearchExpression extends AbstractSearchExpression implements IConditionSearchExpression {
    field?: string | undefined;
    value?: string | undefined;

    constructor(data?: IConditionSearchExpression) {
        super(data);
        this._discriminator = "condition";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.field = _data["field"];
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): ConditionSearchExpression {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionSearchExpression();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): ConditionSearchExpression {
        const json = this.toJSON();
        let result = new ConditionSearchExpression();
        result.init(json);
        return result;
    }
}

export interface IConditionSearchExpression extends IAbstractSearchExpression {
    field?: string | undefined;
    value?: string | undefined;
}

export class GroupSearchExpression extends AbstractSearchExpression implements IGroupSearchExpression {
    expressions?: AbstractSearchExpression[] | undefined;

    constructor(data?: IGroupSearchExpression) {
        super(data);
        this._discriminator = "group";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["expressions"])) {
                this.expressions = [] as any;
                for (let item of _data["expressions"])
                    this.expressions!.push(AbstractSearchExpression.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GroupSearchExpression {
        data = typeof data === 'object' ? data : {};
        let result = new GroupSearchExpression();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.expressions)) {
            data["expressions"] = [];
            for (let item of this.expressions)
                data["expressions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): GroupSearchExpression {
        const json = this.toJSON();
        let result = new GroupSearchExpression();
        result.init(json);
        return result;
    }
}

export interface IGroupSearchExpression extends IAbstractSearchExpression {
    expressions?: AbstractSearchExpression[] | undefined;
}

export class Searchable implements ISearchable {
    filter?: string | undefined;

    constructor(data?: ISearchable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): Searchable {
        data = typeof data === 'object' ? data : {};
        let result = new Searchable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        return data;
    }

    clone(): Searchable {
        const json = this.toJSON();
        let result = new Searchable();
        result.init(json);
        return result;
    }
}

export interface ISearchable {
    filter?: string | undefined;
}

export class PaginatedSearchable extends Searchable implements IPaginatedSearchable {
    sortKey?: string[] | undefined;
    aggregateKeys?: AggregateKeyInfo[] | undefined;
    skip?: number | undefined;
    take?: number | undefined;

    constructor(data?: IPaginatedSearchable) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["sortKey"])) {
                this.sortKey = [] as any;
                for (let item of _data["sortKey"])
                    this.sortKey!.push(item);
            }
            if (Array.isArray(_data["aggregateKeys"])) {
                this.aggregateKeys = [] as any;
                for (let item of _data["aggregateKeys"])
                    this.aggregateKeys!.push(AggregateKeyInfo.fromJS(item));
            }
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static override fromJS(data: any): PaginatedSearchable {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedSearchable();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sortKey)) {
            data["sortKey"] = [];
            for (let item of this.sortKey)
                data["sortKey"].push(item);
        }
        if (Array.isArray(this.aggregateKeys)) {
            data["aggregateKeys"] = [];
            for (let item of this.aggregateKeys)
                data["aggregateKeys"].push(item.toJSON());
        }
        data["skip"] = this.skip;
        data["take"] = this.take;
        super.toJSON(data);
        return data;
    }

    clone(): PaginatedSearchable {
        const json = this.toJSON();
        let result = new PaginatedSearchable();
        result.init(json);
        return result;
    }
}

export interface IPaginatedSearchable extends ISearchable {
    sortKey?: string[] | undefined;
    aggregateKeys?: AggregateKeyInfo[] | undefined;
    skip?: number | undefined;
    take?: number | undefined;
}

export class CustomerSearchCriteria extends PaginatedSearchable implements ICustomerSearchCriteria {

    constructor(data?: ICustomerSearchCriteria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CustomerSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSearchCriteria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): CustomerSearchCriteria {
        const json = this.toJSON();
        let result = new CustomerSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ICustomerSearchCriteria extends IPaginatedSearchable {
}

export class PaginatedResultsOfCustomerGridDto implements IPaginatedResultsOfCustomerGridDto {
    totalCount?: number;
    results?: CustomerGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfCustomerGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CustomerGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfCustomerGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfCustomerGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfCustomerGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfCustomerGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfCustomerGridDto {
    totalCount?: number;
    results?: CustomerGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class CustomerGridDto implements ICustomerGridDto {
    id?: number;
    languageId?: number;
    name?: string | undefined;
    code?: string | undefined;
    isActive?: boolean;
    customerType?: ECustomerType;
    language?: string | undefined;

    constructor(data?: ICustomerGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.languageId = _data["languageId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.isActive = _data["isActive"];
            this.customerType = _data["customerType"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): CustomerGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["languageId"] = this.languageId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["isActive"] = this.isActive;
        data["customerType"] = this.customerType;
        data["language"] = this.language;
        return data;
    }

    clone(): CustomerGridDto {
        const json = this.toJSON();
        let result = new CustomerGridDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerGridDto {
    id?: number;
    languageId?: number;
    name?: string | undefined;
    code?: string | undefined;
    isActive?: boolean;
    customerType?: ECustomerType;
    language?: string | undefined;
}

export class UpdateDataTranslationCommand implements IUpdateDataTranslationCommand {
    updateDataTranslationDto?: UpdateDataTranslationDto | undefined;

    constructor(data?: IUpdateDataTranslationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updateDataTranslationDto = _data["updateDataTranslationDto"] ? UpdateDataTranslationDto.fromJS(_data["updateDataTranslationDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateDataTranslationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDataTranslationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updateDataTranslationDto"] = this.updateDataTranslationDto ? this.updateDataTranslationDto.toJSON() : <any>undefined;
        return data;
    }

    clone(): UpdateDataTranslationCommand {
        const json = this.toJSON();
        let result = new UpdateDataTranslationCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateDataTranslationCommand {
    updateDataTranslationDto?: UpdateDataTranslationDto | undefined;
}

export class UpdateDataTranslationDto implements IUpdateDataTranslationDto {
    dataTranslationValueId?: number | undefined;
    dataTranslationId?: number;
    languageCode?: string | undefined;
    text?: string | undefined;

    constructor(data?: IUpdateDataTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataTranslationValueId = _data["dataTranslationValueId"];
            this.dataTranslationId = _data["dataTranslationId"];
            this.languageCode = _data["languageCode"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): UpdateDataTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDataTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataTranslationValueId"] = this.dataTranslationValueId;
        data["dataTranslationId"] = this.dataTranslationId;
        data["languageCode"] = this.languageCode;
        data["text"] = this.text;
        return data;
    }

    clone(): UpdateDataTranslationDto {
        const json = this.toJSON();
        let result = new UpdateDataTranslationDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateDataTranslationDto {
    dataTranslationValueId?: number | undefined;
    dataTranslationId?: number;
    languageCode?: string | undefined;
    text?: string | undefined;
}

export class Result implements IResult {
    status?: ResultStatus;
    errors?: ResultError[] | undefined;
    isFailure?: boolean;
    isSuccess?: boolean;
    isNone?: boolean;
    isInvalid?: boolean;
    isNotFound?: boolean;
    rawValue?: MaybeOfObject;

    constructor(data?: IResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ResultError.fromJS(item));
            }
            this.isFailure = _data["isFailure"];
            this.isSuccess = _data["isSuccess"];
            this.isNone = _data["isNone"];
            this.isInvalid = _data["isInvalid"];
            this.isNotFound = _data["isNotFound"];
            this.rawValue = _data["rawValue"] ? MaybeOfObject.fromJS(_data["rawValue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Result {
        data = typeof data === 'object' ? data : {};
        let result = new Result();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isFailure"] = this.isFailure;
        data["isSuccess"] = this.isSuccess;
        data["isNone"] = this.isNone;
        data["isInvalid"] = this.isInvalid;
        data["isNotFound"] = this.isNotFound;
        data["rawValue"] = this.rawValue ? this.rawValue.toJSON() : <any>undefined;
        return data;
    }

    clone(): Result {
        const json = this.toJSON();
        let result = new Result();
        result.init(json);
        return result;
    }
}

export interface IResult {
    status?: ResultStatus;
    errors?: ResultError[] | undefined;
    isFailure?: boolean;
    isSuccess?: boolean;
    isNone?: boolean;
    isInvalid?: boolean;
    isNotFound?: boolean;
    rawValue?: MaybeOfObject;
}

export enum ResultStatus {
    Success = "Success",
    Invalid = "Invalid",
    NotFound = "NotFound",
    None = "None",
}

export abstract class ValueObject implements IValueObject {

    constructor(data?: IValueObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ValueObject {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ValueObject' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): ValueObject {
        throw new Error("The abstract class 'ValueObject' cannot be instantiated.");
    }
}

export interface IValueObject {
}

export class ResultError extends ValueObject implements IResultError {
    propertyName?: string | undefined;
    hasPropertyName?: boolean;
    errorCode?: string | undefined;
    errorMessage?: string | undefined;
    errorLevel?: ResultErrorLevel;
    invalidValue?: any | undefined;

    constructor(data?: IResultError) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.hasPropertyName = _data["hasPropertyName"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.errorLevel = _data["errorLevel"];
            this.invalidValue = _data["invalidValue"];
        }
    }

    static override fromJS(data: any): ResultError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultError();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["hasPropertyName"] = this.hasPropertyName;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["errorLevel"] = this.errorLevel;
        data["invalidValue"] = this.invalidValue;
        super.toJSON(data);
        return data;
    }

    clone(): ResultError {
        const json = this.toJSON();
        let result = new ResultError();
        result.init(json);
        return result;
    }
}

export interface IResultError extends IValueObject {
    propertyName?: string | undefined;
    hasPropertyName?: boolean;
    errorCode?: string | undefined;
    errorMessage?: string | undefined;
    errorLevel?: ResultErrorLevel;
    invalidValue?: any | undefined;
}

export enum ResultErrorLevel {
    None = "None",
    Info = "Info",
    Warning = "Warning",
    NotFound = "NotFound",
    Error = "Error",
}

export class MaybeOfObject implements IMaybeOfObject {
    value?: any | undefined;
    hasValue?: boolean;
    hasNoValue?: boolean;

    constructor(data?: IMaybeOfObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.hasValue = _data["hasValue"];
            this.hasNoValue = _data["hasNoValue"];
        }
    }

    static fromJS(data: any): MaybeOfObject {
        data = typeof data === 'object' ? data : {};
        let result = new MaybeOfObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["hasValue"] = this.hasValue;
        data["hasNoValue"] = this.hasNoValue;
        return data;
    }

    clone(): MaybeOfObject {
        const json = this.toJSON();
        let result = new MaybeOfObject();
        result.init(json);
        return result;
    }
}

export interface IMaybeOfObject {
    value?: any | undefined;
    hasValue?: boolean;
    hasNoValue?: boolean;
}

export class PaginatedResultsOfDataTranslationGridDto implements IPaginatedResultsOfDataTranslationGridDto {
    totalCount?: number;
    results?: DataTranslationGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDataTranslationGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DataTranslationGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDataTranslationGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDataTranslationGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfDataTranslationGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfDataTranslationGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfDataTranslationGridDto {
    totalCount?: number;
    results?: DataTranslationGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class DataTranslationGridDto implements IDataTranslationGridDto {
    dataTranslationId?: number;
    entityName?: string | undefined;
    entityId?: number;
    fieldName?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;
    dataTranslationText?: string | undefined;

    constructor(data?: IDataTranslationGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataTranslationId = _data["dataTranslationId"];
            this.entityName = _data["entityName"];
            this.entityId = _data["entityId"];
            this.fieldName = _data["fieldName"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationDto.fromJS(_data["dataTranslation"]) : <any>undefined;
            this.dataTranslationText = _data["dataTranslationText"];
        }
    }

    static fromJS(data: any): DataTranslationGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataTranslationGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataTranslationId"] = this.dataTranslationId;
        data["entityName"] = this.entityName;
        data["entityId"] = this.entityId;
        data["fieldName"] = this.fieldName;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : <any>undefined;
        data["dataTranslationText"] = this.dataTranslationText;
        return data;
    }

    clone(): DataTranslationGridDto {
        const json = this.toJSON();
        let result = new DataTranslationGridDto();
        result.init(json);
        return result;
    }
}

export interface IDataTranslationGridDto {
    dataTranslationId?: number;
    entityName?: string | undefined;
    entityId?: number;
    fieldName?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;
    dataTranslationText?: string | undefined;
}

export class SearchQueryOfDataTranslationInfoSearchCriteria implements ISearchQueryOfDataTranslationInfoSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: DataTranslationInfoSearchCriteria | undefined;

    constructor(data?: ISearchQueryOfDataTranslationInfoSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? DataTranslationInfoSearchCriteria.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfDataTranslationInfoSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfDataTranslationInfoSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfDataTranslationInfoSearchCriteria {
        const json = this.toJSON();
        let result = new SearchQueryOfDataTranslationInfoSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfDataTranslationInfoSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: DataTranslationInfoSearchCriteria | undefined;
}

export class DataTranslationInfoSearchCriteria extends PaginatedSearchable implements IDataTranslationInfoSearchCriteria {

    constructor(data?: IDataTranslationInfoSearchCriteria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DataTranslationInfoSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new DataTranslationInfoSearchCriteria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): DataTranslationInfoSearchCriteria {
        const json = this.toJSON();
        let result = new DataTranslationInfoSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface IDataTranslationInfoSearchCriteria extends IPaginatedSearchable {
}

export class DeliveryOrderEditDto implements IDeliveryOrderEditDto {
    id?: number;
    pdfPath?: string | undefined;
    duplicata?: string | undefined;
    collectionSlip?: string | undefined;
    company?: string | undefined;
    loadingRequest?: string | undefined;
    customerCode?: string | undefined;
    customerName?: string | undefined;
    customerId?: number | undefined;
    editDate?: Date | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    formatedEndTime?: string | undefined;
    carrierCode?: string | undefined;
    productionSite?: string | undefined;
    productCode?: string | undefined;
    quantity?: number;
    tractor?: string | undefined;
    trailer?: string | undefined;
    status?: string | undefined;
    cnlEditDate?: Date | undefined;
    orignialOrderCorrection?: string | undefined;
    longCarrier?: string | undefined;
    shortCarrier?: string | undefined;
    internalItemLong?: string | undefined;
    internalItemShort?: string | undefined;
    itemLabel?: string | undefined;
    clientRef?: string | undefined;
    destination?: string | undefined;

    constructor(data?: IDeliveryOrderEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pdfPath = _data["pdfPath"];
            this.duplicata = _data["duplicata"];
            this.collectionSlip = _data["collectionSlip"];
            this.company = _data["company"];
            this.loadingRequest = _data["loadingRequest"];
            this.customerCode = _data["customerCode"];
            this.customerName = _data["customerName"];
            this.customerId = _data["customerId"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : <any>undefined;
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.formatedEndTime = _data["formatedEndTime"];
            this.carrierCode = _data["carrierCode"];
            this.productionSite = _data["productionSite"];
            this.productCode = _data["productCode"];
            this.quantity = _data["quantity"];
            this.tractor = _data["tractor"];
            this.trailer = _data["trailer"];
            this.status = _data["status"];
            this.cnlEditDate = _data["cnlEditDate"] ? new Date(_data["cnlEditDate"].toString()) : <any>undefined;
            this.orignialOrderCorrection = _data["orignialOrderCorrection"];
            this.longCarrier = _data["longCarrier"];
            this.shortCarrier = _data["shortCarrier"];
            this.internalItemLong = _data["internalItemLong"];
            this.internalItemShort = _data["internalItemShort"];
            this.itemLabel = _data["itemLabel"];
            this.clientRef = _data["clientRef"];
            this.destination = _data["destination"];
        }
    }

    static fromJS(data: any): DeliveryOrderEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryOrderEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pdfPath"] = this.pdfPath;
        data["duplicata"] = this.duplicata;
        data["collectionSlip"] = this.collectionSlip;
        data["company"] = this.company;
        data["loadingRequest"] = this.loadingRequest;
        data["customerCode"] = this.customerCode;
        data["customerName"] = this.customerName;
        data["customerId"] = this.customerId;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : <any>undefined;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["formatedEndTime"] = this.formatedEndTime;
        data["carrierCode"] = this.carrierCode;
        data["productionSite"] = this.productionSite;
        data["productCode"] = this.productCode;
        data["quantity"] = this.quantity;
        data["tractor"] = this.tractor;
        data["trailer"] = this.trailer;
        data["status"] = this.status;
        data["cnlEditDate"] = this.cnlEditDate ? this.cnlEditDate.toISOString() : <any>undefined;
        data["orignialOrderCorrection"] = this.orignialOrderCorrection;
        data["longCarrier"] = this.longCarrier;
        data["shortCarrier"] = this.shortCarrier;
        data["internalItemLong"] = this.internalItemLong;
        data["internalItemShort"] = this.internalItemShort;
        data["itemLabel"] = this.itemLabel;
        data["clientRef"] = this.clientRef;
        data["destination"] = this.destination;
        return data;
    }

    clone(): DeliveryOrderEditDto {
        const json = this.toJSON();
        let result = new DeliveryOrderEditDto();
        result.init(json);
        return result;
    }
}

export interface IDeliveryOrderEditDto {
    id?: number;
    pdfPath?: string | undefined;
    duplicata?: string | undefined;
    collectionSlip?: string | undefined;
    company?: string | undefined;
    loadingRequest?: string | undefined;
    customerCode?: string | undefined;
    customerName?: string | undefined;
    customerId?: number | undefined;
    editDate?: Date | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    formatedEndTime?: string | undefined;
    carrierCode?: string | undefined;
    productionSite?: string | undefined;
    productCode?: string | undefined;
    quantity?: number;
    tractor?: string | undefined;
    trailer?: string | undefined;
    status?: string | undefined;
    cnlEditDate?: Date | undefined;
    orignialOrderCorrection?: string | undefined;
    longCarrier?: string | undefined;
    shortCarrier?: string | undefined;
    internalItemLong?: string | undefined;
    internalItemShort?: string | undefined;
    itemLabel?: string | undefined;
    clientRef?: string | undefined;
    destination?: string | undefined;
}

export class SearchQueryOfDeliveryOrderSearchDto implements ISearchQueryOfDeliveryOrderSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: DeliveryOrderSearchDto | undefined;

    constructor(data?: ISearchQueryOfDeliveryOrderSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? DeliveryOrderSearchDto.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfDeliveryOrderSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfDeliveryOrderSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfDeliveryOrderSearchDto {
        const json = this.toJSON();
        let result = new SearchQueryOfDeliveryOrderSearchDto();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfDeliveryOrderSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: DeliveryOrderSearchDto | undefined;
}

export class DeliveryOrderSearchDto extends PaginatedSearchable implements IDeliveryOrderSearchDto {
    customerIds?: number[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    isCanceled?: boolean | undefined;

    constructor(data?: IDeliveryOrderSearchDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["customerIds"])) {
                this.customerIds = [] as any;
                for (let item of _data["customerIds"])
                    this.customerIds!.push(item);
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.isCanceled = _data["isCanceled"];
        }
    }

    static override fromJS(data: any): DeliveryOrderSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryOrderSearchDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customerIds)) {
            data["customerIds"] = [];
            for (let item of this.customerIds)
                data["customerIds"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isCanceled"] = this.isCanceled;
        super.toJSON(data);
        return data;
    }

    clone(): DeliveryOrderSearchDto {
        const json = this.toJSON();
        let result = new DeliveryOrderSearchDto();
        result.init(json);
        return result;
    }
}

export interface IDeliveryOrderSearchDto extends IPaginatedSearchable {
    customerIds?: number[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    isCanceled?: boolean | undefined;
}

export class PaginatedResultsOfDeliveryOrderGridDto implements IPaginatedResultsOfDeliveryOrderGridDto {
    totalCount?: number;
    results?: DeliveryOrderGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDeliveryOrderGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DeliveryOrderGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDeliveryOrderGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDeliveryOrderGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfDeliveryOrderGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfDeliveryOrderGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfDeliveryOrderGridDto {
    totalCount?: number;
    results?: DeliveryOrderGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class DeliveryOrderGridDto implements IDeliveryOrderGridDto {
    id?: number;
    productionSite?: string | undefined;
    destination?: string | undefined;
    internalItemShort?: string | undefined;
    formattedEditDate?: string | undefined;
    collectionSlip?: string | undefined;
    quantity?: number;
    longCarrier?: string | undefined;
    tractor?: string | undefined;
    trailer?: string | undefined;
    loadingRequest?: string | undefined;
    clientRef?: string | undefined;
    formatedEndTime?: string | undefined;
    customerCode?: string | undefined;
    customerName?: string | undefined;
    formatedCnlEditDate?: string | undefined;
    orignialOrderCorrection?: string | undefined;
    productCode?: string | undefined;
    itemLabel?: string | undefined;
    editDate?: Date | undefined;
    cnlEditDate?: Date | undefined;
    pdfPath?: string | undefined;
    duplicata?: string | undefined;
    company?: string | undefined;
    customerId?: number | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    carrierCode?: string | undefined;
    status?: string | undefined;
    shortCarrier?: string | undefined;
    internalItemLong?: string | undefined;
    isCanceled?: boolean;

    constructor(data?: IDeliveryOrderGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productionSite = _data["productionSite"];
            this.destination = _data["destination"];
            this.internalItemShort = _data["internalItemShort"];
            this.formattedEditDate = _data["formattedEditDate"];
            this.collectionSlip = _data["collectionSlip"];
            this.quantity = _data["quantity"];
            this.longCarrier = _data["longCarrier"];
            this.tractor = _data["tractor"];
            this.trailer = _data["trailer"];
            this.loadingRequest = _data["loadingRequest"];
            this.clientRef = _data["clientRef"];
            this.formatedEndTime = _data["formatedEndTime"];
            this.customerCode = _data["customerCode"];
            this.customerName = _data["customerName"];
            this.formatedCnlEditDate = _data["formatedCnlEditDate"];
            this.orignialOrderCorrection = _data["orignialOrderCorrection"];
            this.productCode = _data["productCode"];
            this.itemLabel = _data["itemLabel"];
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : <any>undefined;
            this.cnlEditDate = _data["cnlEditDate"] ? new Date(_data["cnlEditDate"].toString()) : <any>undefined;
            this.pdfPath = _data["pdfPath"];
            this.duplicata = _data["duplicata"];
            this.company = _data["company"];
            this.customerId = _data["customerId"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.carrierCode = _data["carrierCode"];
            this.status = _data["status"];
            this.shortCarrier = _data["shortCarrier"];
            this.internalItemLong = _data["internalItemLong"];
            this.isCanceled = _data["isCanceled"];
        }
    }

    static fromJS(data: any): DeliveryOrderGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryOrderGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productionSite"] = this.productionSite;
        data["destination"] = this.destination;
        data["internalItemShort"] = this.internalItemShort;
        data["formattedEditDate"] = this.formattedEditDate;
        data["collectionSlip"] = this.collectionSlip;
        data["quantity"] = this.quantity;
        data["longCarrier"] = this.longCarrier;
        data["tractor"] = this.tractor;
        data["trailer"] = this.trailer;
        data["loadingRequest"] = this.loadingRequest;
        data["clientRef"] = this.clientRef;
        data["formatedEndTime"] = this.formatedEndTime;
        data["customerCode"] = this.customerCode;
        data["customerName"] = this.customerName;
        data["formatedCnlEditDate"] = this.formatedCnlEditDate;
        data["orignialOrderCorrection"] = this.orignialOrderCorrection;
        data["productCode"] = this.productCode;
        data["itemLabel"] = this.itemLabel;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : <any>undefined;
        data["cnlEditDate"] = this.cnlEditDate ? this.cnlEditDate.toISOString() : <any>undefined;
        data["pdfPath"] = this.pdfPath;
        data["duplicata"] = this.duplicata;
        data["company"] = this.company;
        data["customerId"] = this.customerId;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["carrierCode"] = this.carrierCode;
        data["status"] = this.status;
        data["shortCarrier"] = this.shortCarrier;
        data["internalItemLong"] = this.internalItemLong;
        data["isCanceled"] = this.isCanceled;
        return data;
    }

    clone(): DeliveryOrderGridDto {
        const json = this.toJSON();
        let result = new DeliveryOrderGridDto();
        result.init(json);
        return result;
    }
}

export interface IDeliveryOrderGridDto {
    id?: number;
    productionSite?: string | undefined;
    destination?: string | undefined;
    internalItemShort?: string | undefined;
    formattedEditDate?: string | undefined;
    collectionSlip?: string | undefined;
    quantity?: number;
    longCarrier?: string | undefined;
    tractor?: string | undefined;
    trailer?: string | undefined;
    loadingRequest?: string | undefined;
    clientRef?: string | undefined;
    formatedEndTime?: string | undefined;
    customerCode?: string | undefined;
    customerName?: string | undefined;
    formatedCnlEditDate?: string | undefined;
    orignialOrderCorrection?: string | undefined;
    productCode?: string | undefined;
    itemLabel?: string | undefined;
    editDate?: Date | undefined;
    cnlEditDate?: Date | undefined;
    pdfPath?: string | undefined;
    duplicata?: string | undefined;
    company?: string | undefined;
    customerId?: number | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    carrierCode?: string | undefined;
    status?: string | undefined;
    shortCarrier?: string | undefined;
    internalItemLong?: string | undefined;
    isCanceled?: boolean;
}

export class LanguageDto implements ILanguageDto {
    id?: number;
    code?: string | undefined;
    label?: string | undefined;
    isActive?: boolean | undefined;
    orderIndex?: number;

    constructor(data?: ILanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.label = _data["label"];
            this.isActive = _data["isActive"];
            this.orderIndex = _data["orderIndex"];
        }
    }

    static fromJS(data: any): LanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["label"] = this.label;
        data["isActive"] = this.isActive;
        data["orderIndex"] = this.orderIndex;
        return data;
    }

    clone(): LanguageDto {
        const json = this.toJSON();
        let result = new LanguageDto();
        result.init(json);
        return result;
    }
}

export interface ILanguageDto {
    id?: number;
    code?: string | undefined;
    label?: string | undefined;
    isActive?: boolean | undefined;
    orderIndex?: number;
}

export class EditSearchCriteriaDto implements IEditSearchCriteriaDto {
    searchCriteriaId?: number;
    searchName?: string | undefined;
    jsonCriteria?: string | undefined;
    advanced?: boolean;
    userId?: number | undefined;

    constructor(data?: IEditSearchCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchCriteriaId = _data["searchCriteriaId"];
            this.searchName = _data["searchName"];
            this.jsonCriteria = _data["jsonCriteria"];
            this.advanced = _data["advanced"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): EditSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditSearchCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchCriteriaId"] = this.searchCriteriaId;
        data["searchName"] = this.searchName;
        data["jsonCriteria"] = this.jsonCriteria;
        data["advanced"] = this.advanced;
        data["userId"] = this.userId;
        return data;
    }

    clone(): EditSearchCriteriaDto {
        const json = this.toJSON();
        let result = new EditSearchCriteriaDto();
        result.init(json);
        return result;
    }
}

export interface IEditSearchCriteriaDto {
    searchCriteriaId?: number;
    searchName?: string | undefined;
    jsonCriteria?: string | undefined;
    advanced?: boolean;
    userId?: number | undefined;
}

export class SystemInfoDto implements ISystemInfoDto {
    applicationName?: string | undefined;
    applicationVersion?: string | undefined;
    environment?: string | undefined;
    database?: string | undefined;

    constructor(data?: ISystemInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationName = _data["applicationName"];
            this.applicationVersion = _data["applicationVersion"];
            this.environment = _data["environment"];
            this.database = _data["database"];
        }
    }

    static fromJS(data: any): SystemInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationName"] = this.applicationName;
        data["applicationVersion"] = this.applicationVersion;
        data["environment"] = this.environment;
        data["database"] = this.database;
        return data;
    }

    clone(): SystemInfoDto {
        const json = this.toJSON();
        let result = new SystemInfoDto();
        result.init(json);
        return result;
    }
}

export interface ISystemInfoDto {
    applicationName?: string | undefined;
    applicationVersion?: string | undefined;
    environment?: string | undefined;
    database?: string | undefined;
}

export class ExposedTypes implements IExposedTypes {
    actionCode?: ActionCode;
    errorDetails?: ErrorDetails | undefined;
    errorResult?: ResultError | undefined;
    dataTranslationDto?: DataTranslationDto | undefined;
    resultErrors?: ResultError[] | undefined;

    constructor(data?: IExposedTypes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionCode = _data["actionCode"];
            this.errorDetails = _data["errorDetails"] ? ErrorDetails.fromJS(_data["errorDetails"]) : <any>undefined;
            this.errorResult = _data["errorResult"] ? ResultError.fromJS(_data["errorResult"]) : <any>undefined;
            this.dataTranslationDto = _data["dataTranslationDto"] ? DataTranslationDto.fromJS(_data["dataTranslationDto"]) : <any>undefined;
            if (Array.isArray(_data["resultErrors"])) {
                this.resultErrors = [] as any;
                for (let item of _data["resultErrors"])
                    this.resultErrors!.push(ResultError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExposedTypes {
        data = typeof data === 'object' ? data : {};
        let result = new ExposedTypes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionCode"] = this.actionCode;
        data["errorDetails"] = this.errorDetails ? this.errorDetails.toJSON() : <any>undefined;
        data["errorResult"] = this.errorResult ? this.errorResult.toJSON() : <any>undefined;
        data["dataTranslationDto"] = this.dataTranslationDto ? this.dataTranslationDto.toJSON() : <any>undefined;
        if (Array.isArray(this.resultErrors)) {
            data["resultErrors"] = [];
            for (let item of this.resultErrors)
                data["resultErrors"].push(item.toJSON());
        }
        return data;
    }

    clone(): ExposedTypes {
        const json = this.toJSON();
        let result = new ExposedTypes();
        result.init(json);
        return result;
    }
}

export interface IExposedTypes {
    actionCode?: ActionCode;
    errorDetails?: ErrorDetails | undefined;
    errorResult?: ResultError | undefined;
    dataTranslationDto?: DataTranslationDto | undefined;
    resultErrors?: ResultError[] | undefined;
}

export class ErrorDetails implements IErrorDetails {
    statusCode?: number;
    message?: string | undefined;
    stackTrace?: string | undefined;
    exceptionType?: string | undefined;
    errorCode?: string | undefined;

    constructor(data?: IErrorDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.stackTrace = _data["stackTrace"];
            this.exceptionType = _data["exceptionType"];
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): ErrorDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["stackTrace"] = this.stackTrace;
        data["exceptionType"] = this.exceptionType;
        data["errorCode"] = this.errorCode;
        return data;
    }

    clone(): ErrorDetails {
        const json = this.toJSON();
        let result = new ErrorDetails();
        result.init(json);
        return result;
    }
}

export interface IErrorDetails {
    statusCode?: number;
    message?: string | undefined;
    stackTrace?: string | undefined;
    exceptionType?: string | undefined;
    errorCode?: string | undefined;
}

export class FrontendSettings implements IFrontendSettings {
    keycloakUrl?: string | undefined;
    keycloakRealm?: string | undefined;
    keycloakClientId?: string | undefined;

    constructor(data?: IFrontendSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keycloakUrl = _data["keycloakUrl"];
            this.keycloakRealm = _data["keycloakRealm"];
            this.keycloakClientId = _data["keycloakClientId"];
        }
    }

    static fromJS(data: any): FrontendSettings {
        data = typeof data === 'object' ? data : {};
        let result = new FrontendSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keycloakUrl"] = this.keycloakUrl;
        data["keycloakRealm"] = this.keycloakRealm;
        data["keycloakClientId"] = this.keycloakClientId;
        return data;
    }

    clone(): FrontendSettings {
        const json = this.toJSON();
        let result = new FrontendSettings();
        result.init(json);
        return result;
    }
}

export interface IFrontendSettings {
    keycloakUrl?: string | undefined;
    keycloakRealm?: string | undefined;
    keycloakClientId?: string | undefined;
}

export class PaginatedResultsOfTranslationCodeDto implements IPaginatedResultsOfTranslationCodeDto {
    totalCount?: number;
    results?: TranslationCodeDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfTranslationCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TranslationCodeDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfTranslationCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfTranslationCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfTranslationCodeDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfTranslationCodeDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfTranslationCodeDto {
    totalCount?: number;
    results?: TranslationCodeDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class TranslationCodeDto implements ITranslationCodeDto {
    id?: number;
    translationCode?: string | undefined;
    toTranslate?: boolean;
    dataTranslationValues?: TranslationValueDto[] | undefined;

    constructor(data?: ITranslationCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.translationCode = _data["translationCode"];
            this.toTranslate = _data["toTranslate"];
            if (Array.isArray(_data["dataTranslationValues"])) {
                this.dataTranslationValues = [] as any;
                for (let item of _data["dataTranslationValues"])
                    this.dataTranslationValues!.push(TranslationValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TranslationCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["translationCode"] = this.translationCode;
        data["toTranslate"] = this.toTranslate;
        if (Array.isArray(this.dataTranslationValues)) {
            data["dataTranslationValues"] = [];
            for (let item of this.dataTranslationValues)
                data["dataTranslationValues"].push(item.toJSON());
        }
        return data;
    }

    clone(): TranslationCodeDto {
        const json = this.toJSON();
        let result = new TranslationCodeDto();
        result.init(json);
        return result;
    }
}

export interface ITranslationCodeDto {
    id?: number;
    translationCode?: string | undefined;
    toTranslate?: boolean;
    dataTranslationValues?: TranslationValueDto[] | undefined;
}

export class TranslationValueDto implements ITranslationValueDto {
    id?: number;
    text?: string | undefined;
    languageId?: number;
    languageCode?: string | undefined;

    constructor(data?: ITranslationValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.languageId = _data["languageId"];
            this.languageCode = _data["languageCode"];
        }
    }

    static fromJS(data: any): TranslationValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["languageId"] = this.languageId;
        data["languageCode"] = this.languageCode;
        return data;
    }

    clone(): TranslationValueDto {
        const json = this.toJSON();
        let result = new TranslationValueDto();
        result.init(json);
        return result;
    }
}

export interface ITranslationValueDto {
    id?: number;
    text?: string | undefined;
    languageId?: number;
    languageCode?: string | undefined;
}

export class SearchQueryOfTranslationCodeSearchCriteria implements ISearchQueryOfTranslationCodeSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: TranslationCodeSearchCriteria | undefined;

    constructor(data?: ISearchQueryOfTranslationCodeSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? TranslationCodeSearchCriteria.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfTranslationCodeSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfTranslationCodeSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfTranslationCodeSearchCriteria {
        const json = this.toJSON();
        let result = new SearchQueryOfTranslationCodeSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfTranslationCodeSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: TranslationCodeSearchCriteria | undefined;
}

export class TranslationCodeSearchCriteria extends PaginatedSearchable implements ITranslationCodeSearchCriteria {

    constructor(data?: ITranslationCodeSearchCriteria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): TranslationCodeSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationCodeSearchCriteria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): TranslationCodeSearchCriteria {
        const json = this.toJSON();
        let result = new TranslationCodeSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ITranslationCodeSearchCriteria extends IPaginatedSearchable {
}

export class TranslationDto implements ITranslationDto {
    languageCode?: string | undefined;
    translationCode?: string | undefined;
    text?: string | undefined;
    translationId?: number;
    languageId?: number;
    createdOn?: Date;
    updatedOn?: Date;
    toTranslate?: boolean;

    constructor(data?: ITranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageCode = _data["languageCode"];
            this.translationCode = _data["translationCode"];
            this.text = _data["text"];
            this.translationId = _data["translationId"];
            this.languageId = _data["languageId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.toTranslate = _data["toTranslate"];
        }
    }

    static fromJS(data: any): TranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageCode"] = this.languageCode;
        data["translationCode"] = this.translationCode;
        data["text"] = this.text;
        data["translationId"] = this.translationId;
        data["languageId"] = this.languageId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["toTranslate"] = this.toTranslate;
        return data;
    }

    clone(): TranslationDto {
        const json = this.toJSON();
        let result = new TranslationDto();
        result.init(json);
        return result;
    }
}

export interface ITranslationDto {
    languageCode?: string | undefined;
    translationCode?: string | undefined;
    text?: string | undefined;
    translationId?: number;
    languageId?: number;
    createdOn?: Date;
    updatedOn?: Date;
    toTranslate?: boolean;
}

export class SearchQueryOfTranslationSearchCriteria implements ISearchQueryOfTranslationSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: TranslationSearchCriteria | undefined;

    constructor(data?: ISearchQueryOfTranslationSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? TranslationSearchCriteria.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfTranslationSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfTranslationSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfTranslationSearchCriteria {
        const json = this.toJSON();
        let result = new SearchQueryOfTranslationSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfTranslationSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: TranslationSearchCriteria | undefined;
}

export class TranslationSearchCriteria extends PaginatedSearchable implements ITranslationSearchCriteria {
    languageCode?: string | undefined;

    constructor(data?: ITranslationSearchCriteria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageCode = _data["languageCode"];
        }
    }

    static override fromJS(data: any): TranslationSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationSearchCriteria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageCode"] = this.languageCode;
        super.toJSON(data);
        return data;
    }

    clone(): TranslationSearchCriteria {
        const json = this.toJSON();
        let result = new TranslationSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ITranslationSearchCriteria extends IPaginatedSearchable {
    languageCode?: string | undefined;
}

export class SaveTranslationDto implements ISaveTranslationDto {
    translationCode?: string | undefined;
    languageCode?: string | undefined;
    text?: string | undefined;

    constructor(data?: ISaveTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.translationCode = _data["translationCode"];
            this.languageCode = _data["languageCode"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): SaveTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["translationCode"] = this.translationCode;
        data["languageCode"] = this.languageCode;
        data["text"] = this.text;
        return data;
    }

    clone(): SaveTranslationDto {
        const json = this.toJSON();
        let result = new SaveTranslationDto();
        result.init(json);
        return result;
    }
}

export interface ISaveTranslationDto {
    translationCode?: string | undefined;
    languageCode?: string | undefined;
    text?: string | undefined;
}

export class UpdateTranslationCommand implements IUpdateTranslationCommand {
    translationId?: number;
    text?: string | undefined;

    constructor(data?: IUpdateTranslationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.translationId = _data["translationId"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): UpdateTranslationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTranslationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["translationId"] = this.translationId;
        data["text"] = this.text;
        return data;
    }

    clone(): UpdateTranslationCommand {
        const json = this.toJSON();
        let result = new UpdateTranslationCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateTranslationCommand {
    translationId?: number;
    text?: string | undefined;
}

export class PaginatedResultsOfTranslationDto implements IPaginatedResultsOfTranslationDto {
    totalCount?: number;
    results?: TranslationDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TranslationDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfTranslationDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfTranslationDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfTranslationDto {
    totalCount?: number;
    results?: TranslationDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class PaginatedResultsOfUserActionGridDto implements IPaginatedResultsOfUserActionGridDto {
    totalCount?: number;
    results?: UserActionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfUserActionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(UserActionGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfUserActionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfUserActionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfUserActionGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfUserActionGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfUserActionGridDto {
    totalCount?: number;
    results?: UserActionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class UserActionGridDto implements IUserActionGridDto {
    contactId?: number;
    fullName?: string | undefined;
    login?: string | undefined;
    roles?: string[] | undefined;
    permissions?: number;

    constructor(data?: IUserActionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.fullName = _data["fullName"];
            this.login = _data["login"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.permissions = _data["permissions"];
        }
    }

    static fromJS(data: any): UserActionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserActionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["fullName"] = this.fullName;
        data["login"] = this.login;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["permissions"] = this.permissions;
        return data;
    }

    clone(): UserActionGridDto {
        const json = this.toJSON();
        let result = new UserActionGridDto();
        result.init(json);
        return result;
    }
}

export interface IUserActionGridDto {
    contactId?: number;
    fullName?: string | undefined;
    login?: string | undefined;
    roles?: string[] | undefined;
    permissions?: number;
}

export class UserActionSearchDto extends PaginatedSearch implements IUserActionSearchDto {
    fullName?: TextSearch | undefined;
    login?: TextSearch | undefined;

    constructor(data?: IUserActionSearchDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fullName = _data["fullName"] ? TextSearch.fromJS(_data["fullName"]) : <any>undefined;
            this.login = _data["login"] ? TextSearch.fromJS(_data["login"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): UserActionSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserActionSearchDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName ? this.fullName.toJSON() : <any>undefined;
        data["login"] = this.login ? this.login.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): UserActionSearchDto {
        const json = this.toJSON();
        let result = new UserActionSearchDto();
        result.init(json);
        return result;
    }
}

export interface IUserActionSearchDto extends IPaginatedSearch {
    fullName?: TextSearch | undefined;
    login?: TextSearch | undefined;
}

export abstract class FilterCriteriaBaseOfETextSearchTypeAndString implements IFilterCriteriaBaseOfETextSearchTypeAndString {
    criterias?: CombinableCriteriaOfETextSearchTypeAndString[] | undefined;
    searchMode?: ETextSearchType;
    value?: string | undefined;
    secondaryValue?: string | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;

    constructor(data?: IFilterCriteriaBaseOfETextSearchTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["criterias"])) {
                this.criterias = [] as any;
                for (let item of _data["criterias"])
                    this.criterias!.push(CombinableCriteriaOfETextSearchTypeAndString.fromJS(item));
            }
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
            if (Array.isArray(_data["availableSearchTypes"])) {
                this.availableSearchTypes = [] as any;
                for (let item of _data["availableSearchTypes"])
                    this.availableSearchTypes!.push(item);
            }
            this.defaultSearchType = _data["defaultSearchType"];
        }
    }

    static fromJS(data: any): FilterCriteriaBaseOfETextSearchTypeAndString {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'FilterCriteriaBaseOfETextSearchTypeAndString' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.criterias)) {
            data["criterias"] = [];
            for (let item of this.criterias)
                data["criterias"].push(item.toJSON());
        }
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        if (Array.isArray(this.availableSearchTypes)) {
            data["availableSearchTypes"] = [];
            for (let item of this.availableSearchTypes)
                data["availableSearchTypes"].push(item);
        }
        data["defaultSearchType"] = this.defaultSearchType;
        return data;
    }

    clone(): FilterCriteriaBaseOfETextSearchTypeAndString {
        throw new Error("The abstract class 'FilterCriteriaBaseOfETextSearchTypeAndString' cannot be instantiated.");
    }
}

export interface IFilterCriteriaBaseOfETextSearchTypeAndString {
    criterias?: CombinableCriteriaOfETextSearchTypeAndString[] | undefined;
    searchMode?: ETextSearchType;
    value?: string | undefined;
    secondaryValue?: string | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;
}

export class TextSearch extends FilterCriteriaBaseOfETextSearchTypeAndString implements ITextSearch {

    constructor(data?: ITextSearch) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): TextSearch {
        data = typeof data === 'object' ? data : {};
        let result = new TextSearch();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): TextSearch {
        const json = this.toJSON();
        let result = new TextSearch();
        result.init(json);
        return result;
    }
}

export interface ITextSearch extends IFilterCriteriaBaseOfETextSearchTypeAndString {
}

export class CombinableCriteriaOfETextSearchTypeAndString implements ICombinableCriteriaOfETextSearchTypeAndString {
    searchMode?: ETextSearchType;
    value?: string | undefined;
    secondaryValue?: string | undefined;

    constructor(data?: ICombinableCriteriaOfETextSearchTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
        }
    }

    static fromJS(data: any): CombinableCriteriaOfETextSearchTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new CombinableCriteriaOfETextSearchTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        return data;
    }

    clone(): CombinableCriteriaOfETextSearchTypeAndString {
        const json = this.toJSON();
        let result = new CombinableCriteriaOfETextSearchTypeAndString();
        result.init(json);
        return result;
    }
}

export interface ICombinableCriteriaOfETextSearchTypeAndString {
    searchMode?: ETextSearchType;
    value?: string | undefined;
    secondaryValue?: string | undefined;
}

export enum ETextSearchType {
    StartWith = "StartWith",
    EndWith = "EndWith",
    Contains = "Contains",
    NotContains = "NotContains",
    Equals = "Equals",
    NotEquals = "NotEquals",
}

export class EditUserDto implements IEditUserDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    login?: string | undefined;
    id?: number;
    roles?: number[] | undefined;
    rolesToString?: string[] | undefined;
    isActive?: boolean;
    fullName?: string | undefined;
    roleName?: UserRoles;
    identityServiceId?: string | undefined;
    customerIds?: number[] | undefined;
    languageId?: number | undefined;
    ensureMfa?: boolean;
    isEmailVerified?: boolean;

    constructor(data?: IEditUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.login = _data["login"];
            this.id = _data["id"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["rolesToString"])) {
                this.rolesToString = [] as any;
                for (let item of _data["rolesToString"])
                    this.rolesToString!.push(item);
            }
            this.isActive = _data["isActive"];
            this.fullName = _data["fullName"];
            this.roleName = _data["roleName"];
            this.identityServiceId = _data["identityServiceId"];
            if (Array.isArray(_data["customerIds"])) {
                this.customerIds = [] as any;
                for (let item of _data["customerIds"])
                    this.customerIds!.push(item);
            }
            this.languageId = _data["languageId"];
            this.ensureMfa = _data["ensureMfa"];
            this.isEmailVerified = _data["isEmailVerified"];
        }
    }

    static fromJS(data: any): EditUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["login"] = this.login;
        data["id"] = this.id;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.rolesToString)) {
            data["rolesToString"] = [];
            for (let item of this.rolesToString)
                data["rolesToString"].push(item);
        }
        data["isActive"] = this.isActive;
        data["fullName"] = this.fullName;
        data["roleName"] = this.roleName;
        data["identityServiceId"] = this.identityServiceId;
        if (Array.isArray(this.customerIds)) {
            data["customerIds"] = [];
            for (let item of this.customerIds)
                data["customerIds"].push(item);
        }
        data["languageId"] = this.languageId;
        data["ensureMfa"] = this.ensureMfa;
        data["isEmailVerified"] = this.isEmailVerified;
        return data;
    }

    clone(): EditUserDto {
        const json = this.toJSON();
        let result = new EditUserDto();
        result.init(json);
        return result;
    }
}

export interface IEditUserDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    login?: string | undefined;
    id?: number;
    roles?: number[] | undefined;
    rolesToString?: string[] | undefined;
    isActive?: boolean;
    fullName?: string | undefined;
    roleName?: UserRoles;
    identityServiceId?: string | undefined;
    customerIds?: number[] | undefined;
    languageId?: number | undefined;
    ensureMfa?: boolean;
    isEmailVerified?: boolean;
}

export class SearchQueryOfUserSearchCriteria implements ISearchQueryOfUserSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: UserSearchCriteria | undefined;

    constructor(data?: ISearchQueryOfUserSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? UserSearchCriteria.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfUserSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfUserSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfUserSearchCriteria {
        const json = this.toJSON();
        let result = new SearchQueryOfUserSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfUserSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: UserSearchCriteria | undefined;
}

export class UserSearchCriteria extends PaginatedSearchable implements IUserSearchCriteria {
    customerIds?: number[] | undefined;

    constructor(data?: IUserSearchCriteria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["customerIds"])) {
                this.customerIds = [] as any;
                for (let item of _data["customerIds"])
                    this.customerIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): UserSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new UserSearchCriteria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customerIds)) {
            data["customerIds"] = [];
            for (let item of this.customerIds)
                data["customerIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): UserSearchCriteria {
        const json = this.toJSON();
        let result = new UserSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface IUserSearchCriteria extends IPaginatedSearchable {
    customerIds?: number[] | undefined;
}

export class PaginatedResultsOfUserGridDto implements IPaginatedResultsOfUserGridDto {
    totalCount?: number;
    results?: UserGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfUserGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(UserGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfUserGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfUserGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfUserGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfUserGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfUserGridDto {
    totalCount?: number;
    results?: UserGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class UserGridDto implements IUserGridDto {
    id?: number;
    contactId?: number;
    role?: string[] | undefined;
    hasSpecificPermissions?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    login?: string | undefined;
    roles?: string | undefined;
    language?: string | undefined;
    isActive?: boolean;
    ensureMfa?: boolean;

    constructor(data?: IUserGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactId = _data["contactId"];
            if (Array.isArray(_data["role"])) {
                this.role = [] as any;
                for (let item of _data["role"])
                    this.role!.push(item);
            }
            this.hasSpecificPermissions = _data["hasSpecificPermissions"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.login = _data["login"];
            this.roles = _data["roles"];
            this.language = _data["language"];
            this.isActive = _data["isActive"];
            this.ensureMfa = _data["ensureMfa"];
        }
    }

    static fromJS(data: any): UserGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactId"] = this.contactId;
        if (Array.isArray(this.role)) {
            data["role"] = [];
            for (let item of this.role)
                data["role"].push(item);
        }
        data["hasSpecificPermissions"] = this.hasSpecificPermissions;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["login"] = this.login;
        data["roles"] = this.roles;
        data["language"] = this.language;
        data["isActive"] = this.isActive;
        data["ensureMfa"] = this.ensureMfa;
        return data;
    }

    clone(): UserGridDto {
        const json = this.toJSON();
        let result = new UserGridDto();
        result.init(json);
        return result;
    }
}

export interface IUserGridDto {
    id?: number;
    contactId?: number;
    role?: string[] | undefined;
    hasSpecificPermissions?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    login?: string | undefined;
    roles?: string | undefined;
    language?: string | undefined;
    isActive?: boolean;
    ensureMfa?: boolean;
}

export class HealthCheckViewModel implements IHealthCheckViewModel {
    globalStatus?: string | undefined;
    checkTime?: Date;
    worstExecutionTime?: string | undefined;
    totalExecutionTime?: string | undefined;
    entries?: HealthCheckEntryViewModel[] | undefined;

    constructor(data?: IHealthCheckViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.globalStatus = _data["globalStatus"];
            this.checkTime = _data["checkTime"] ? new Date(_data["checkTime"].toString()) : <any>undefined;
            this.worstExecutionTime = _data["worstExecutionTime"];
            this.totalExecutionTime = _data["totalExecutionTime"];
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(HealthCheckEntryViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HealthCheckViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["globalStatus"] = this.globalStatus;
        data["checkTime"] = this.checkTime ? this.checkTime.toISOString() : <any>undefined;
        data["worstExecutionTime"] = this.worstExecutionTime;
        data["totalExecutionTime"] = this.totalExecutionTime;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        return data;
    }

    clone(): HealthCheckViewModel {
        const json = this.toJSON();
        let result = new HealthCheckViewModel();
        result.init(json);
        return result;
    }
}

export interface IHealthCheckViewModel {
    globalStatus?: string | undefined;
    checkTime?: Date;
    worstExecutionTime?: string | undefined;
    totalExecutionTime?: string | undefined;
    entries?: HealthCheckEntryViewModel[] | undefined;
}

export class HealthCheckEntryViewModel implements IHealthCheckEntryViewModel {
    name?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    statusDescription?: string | undefined;
    executionTime?: string | undefined;
    context?: { [key: string]: string[]; } | undefined;

    constructor(data?: IHealthCheckEntryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.statusDescription = _data["statusDescription"];
            this.executionTime = _data["executionTime"];
            if (_data["context"]) {
                this.context = {} as any;
                for (let key in _data["context"]) {
                    if (_data["context"].hasOwnProperty(key))
                        (<any>this.context)![key] = _data["context"][key] !== undefined ? _data["context"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): HealthCheckEntryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckEntryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["statusDescription"] = this.statusDescription;
        data["executionTime"] = this.executionTime;
        if (this.context) {
            data["context"] = {};
            for (let key in this.context) {
                if (this.context.hasOwnProperty(key))
                    (<any>data["context"])[key] = (<any>this.context)[key];
            }
        }
        return data;
    }

    clone(): HealthCheckEntryViewModel {
        const json = this.toJSON();
        let result = new HealthCheckEntryViewModel();
        result.init(json);
        return result;
    }
}

export interface IHealthCheckEntryViewModel {
    name?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    statusDescription?: string | undefined;
    executionTime?: string | undefined;
    context?: { [key: string]: string[]; } | undefined;
}

export class ClientApiKey implements IClientApiKey {
    clientName?: string | undefined;
    clientId?: string | undefined;
    apiKey?: string | undefined;
    hashedApiKey?: string | undefined;

    constructor(data?: IClientApiKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientName = _data["clientName"];
            this.clientId = _data["clientId"];
            this.apiKey = _data["apiKey"];
            this.hashedApiKey = _data["hashedApiKey"];
        }
    }

    static fromJS(data: any): ClientApiKey {
        data = typeof data === 'object' ? data : {};
        let result = new ClientApiKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientName"] = this.clientName;
        data["clientId"] = this.clientId;
        data["apiKey"] = this.apiKey;
        data["hashedApiKey"] = this.hashedApiKey;
        return data;
    }

    clone(): ClientApiKey {
        const json = this.toJSON();
        let result = new ClientApiKey();
        result.init(json);
        return result;
    }
}

export interface IClientApiKey {
    clientName?: string | undefined;
    clientId?: string | undefined;
    apiKey?: string | undefined;
    hashedApiKey?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}

export const BASE_PATH = "http://localhost".replace(/\/+$/, "");

export interface Middleware {
  pre?(context: RequestInit): Promise<RequestInit | void>;

  post?(response: Response): Promise<Response | void>;
}

export interface Configuration {
  basePath?: string; // override base path
  apiKey?: string; // parameter for apiKey security
  apiKeyPromise?: () => Promise<string>;
  headers?: HTTPHeaders; //header params we want to use on every request
  credentials?: RequestCredentials; //value for the credentials param we want to use on each request
  middlewares?: Middleware[];
}

export type Json = any;
export type HTTPMethod =
  | "GET"
  | "POST"
  | "PUT"
  | "PATCH"
  | "DELETE"
  | "OPTIONS";
export type HTTPHeaders = { [key: string]: string };